import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { FriendshipRaceLogin, VarstvoLogin } from '../../../models/types';
import Swal from 'sweetalert2';
import { Form } from '@angular/forms';

@Component({
  selector: 'app-varstvo-prijava',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './varstvo-prijava.component.html',
  styleUrl: './varstvo-prijava.component.scss'
})
export class VarstvoPrijavaComponent {
  varstvoForm: FormGroup;
  kids: VarstvoLogin[] = [];
  
  @Input() isOrgAdmin: boolean = false;


  constructor(private fb: FormBuilder, private organisationService: OrganisationServiceService) {
    this.varstvoForm = this.fb.group({
      name: ['', Validators.required],
      yearOfBirth: [0, Validators.required],
      sex: ['', Validators.required],
      address: ['', Validators.required],
      gradeInSchool: [0, Validators.required],
      parent1Name: [''],
      parent1Address: [''],
      parent1Phone: [''],
      parent1Email: ['', Validators.email],
      parent2Name: [''],
      parent2Address: [''],
      parent2Phone: [''],
      parent2Email: ['', Validators.email],
      hotejeClub: [false],
      allergies: [''],
      timeStamp: [''],
    }, { validators: this.atLeastOneParentValidator });
  }

  private atLeastOneParentValidator(group: FormGroup): { [key: string]: boolean } | null {
    const parent1Valid = group.get('parent1Name')?.value || group.get('parent1Address')?.value || group.get('parent1Phone')?.value || group.get('parent1Email')?.value;
    const parent2Valid = group.get('parent2Name')?.value || group.get('parent2Address')?.value || group.get('parent2Phone')?.value || group.get('parent2Email')?.value;

    if (parent1Valid || parent2Valid) {
      return null; // Validation passes
    }
    return { atLeastOneParentRequired: true }; // Validation fails
  }

  ngOnInit(): void {
    this.getKids();
  }

  getKids(): void {
    this.organisationService.getKids().subscribe({
      next: (response) => {
        this.kids = response.varstvo;
        console.log('Fetched kids:', this.kids);
      },
      error: (error) => {
        console.error('Error fetching kids:', error);
      }
    });
  }

  onSubmit(): void {
    if (this.varstvoForm?.valid) {
      this.organisationService.enrollInVarstvo(this.varstvoForm.value).subscribe({
        next: (response) => {
          Swal.fire({
            icon: 'success',
            title: 'Uspešna prijava',
            text: 'Uspešno ste se prijavili Hotenjski športni teden!',
          }).then(() => {
            window.location.reload();
          });
        },
        error: (error) => {
          console.error('Error submitting form:', error);
          Swal.fire({
            icon: 'error',
            title: 'Napaka',
            text: 'Prišlo je do napake pri prijavi. Prosim, poskusite znova.',
          });
        }
      });
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Napaka',
        text: 'Prosim, izpolnite vsa obvezna polja.',
      });
    }
  }

  downloadCSV(): void {
    this.organisationService.downloadVarstvoCSV().subscribe({
      next: (response: Blob) => {
        // Create a URL for the Blob response and trigger the download
        const url = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'tekPrijateljstvaTekmovalci.csv'; // Filename of the CSV
        link.click();
        window.URL.revokeObjectURL(url); // Clean up the URL object
      },
      error: (error) => {
        console.error('Error downloading CSV:', error);
      },
    });
  }
}
